var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":""}},[_c('h1',{staticClass:"pa-5"},[_vm._v("RECON COVID-19 CHALLENGE")]),_c('call-to-action',{attrs:{"token":_vm.token,"user":_vm.user}}),_c('quick-facts')],1)}
var staticRenderFns = []

export { render, staticRenderFns }